module.exports = __webpack_public_path__ + "img/getboardedlogo3.1c711fbf.png";